<template>
	<!-- <base-modal :show="!!error" title="An error occurred" @close="handleError">
		<p>{{ error }}</p>
	</base-modal> -->
	<div class="card text-info" style="background-color: #263238">
		<div class="card-header">
			<h3>Create Schedule for {{ truncLeagueName }}</h3>
		</div>
		<div class="card-body">
		<button @click="schedule" class="btn btn-outline-info  mb-5">
			New Schedule
		</button>
			<table class="table bg-info">
				<thead>
					<tr>
						<th scope="col">Week</th>
						<th scope="col">Home</th>
						<th scope="col"></th>

						<th scope="col">Away</th>
					</tr>
				</thead>
				<tbody></tbody>
				<tbody>
					<tr v-for="games in gameSchedule" :key="games">
						<td>
							{{ games.week }}
						</td>
						<td>{{ games.home }}</td>
						<td>vs</td>
						<td>{{ games.away }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<form class="mt-5 mb-5" @submit.prevent="saveSchedule">
		<input hidden type="text" v-model="gameSchedule" />
		<div class="form-floating mt-2">
			<input
				type="text"
				class="form-control"
				id="floatingSeason"
				placeholder="Season"
				v-model.trim="season.val"
			/>
			<label for="floatingLName">Season</label>
		</div>
		<button :disabled="isLoading" class="btn btn-outline-info mt-4 btn-lg">
			<div v-show="isLoading">
				<i class="fa-solid fa-baseball fa-spin"></i>
				Saving...
			</div>
			<div v-show="!isLoading">Save Schedule</div>
		</button>
	</form>
</template>

<script>
import generator from "tournament-generator";
export default {
	props:['division'],
	emits: ["close-schedule-modal"],
	data() {
		return {
			gameSchedule: [],
			season: {
				val: "",
				isValid: true,
			},
			error: null,
			isLoading: false
		};
	},
	created(){
	},
	computed: {
		teams() {
			return this.$store.getters["teams/allTeams"];
		},
		userLeague() {
			return this.$store.getters.userLeague;
		},
		truncLeagueName() {
			const league = this.$store.getters.userLeague
			const index = league.indexOf("-")
			return league.slice(0,index)
		},
	},
	watch:{
		selectedDivision(){
			this.loadTeams()
		}
	},
	methods: {
		schedule() {
			var teams = this.$store.getters["teams/allTeams"];
			const schedule = ({ data: teams } = generator(teams, {
				type: "double-round",
			}));
			const games = [];
			const fields = [];
			for (let i = 0; i < schedule.data.length; i++) {
				games.push({
					week: schedule.data[i].round,
					home: schedule.data[i].homeTeam.team,
					away: schedule.data[i].awayTeam.team,
				});
			}
			this.gameSchedule = games;
			return games;
		},
		async saveSchedule() {
			const payload = {
				schedule: this.gameSchedule,
				season: this.season.val,
				divisionId: this.division.id
			};
			try {
				this.isLoading = true
				await this.$store.dispatch("leagues/newSchedule", payload);
			} catch (error) {
				this.error = error.message || "Something failed!";
			}
			setTimeout(()=> {
				this.$emit("close-schedule-modal");
				this.isLoading = false
			}, 1500)
		},
		async loadTeams() {
			const payload = {
				divisionId: this.selectedDivision.id
			}
			try {
				this.isLoading = true;
				await this.$store.dispatch('teams/fetchManagerTeams', payload);
			} catch (error) {
				this.error = error.message || 'Something failed!';
			}
			this.isLoading = false;
		},
	},
};
</script>
